// extracted by mini-css-extract-plugin
module.exports = {"Label":"css-modules_Label__mzO8t","Checkbox":"css-modules_Checkbox___OcFK","Indicator":"css-modules_Indicator__8Dw4b","Icon":"css-modules_Icon__HplVw"};